import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import BinTrf02Actions, { BinTrf02Types } from '../Stores/BinTrf02/Actions';

const getAppStore = state => state.app;

export function* binTrf02FetchBinTrf02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(BinTrf02Actions.binTrf02FetchBinTrf02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `binTrf/indexProcess/BIN_TRF_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        BinTrf02Actions.binTrf02FetchBinTrf02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrf02Actions.binTrf02FetchBinTrf02Loading(false));
  }
}

export function* binTrf02PrintBinTrf02({ hdrIds }) {
  try {
    yield put(BinTrf02Actions.binTrf02PrintBinTrf02Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `binTrf/printProcess/BIN_TRF_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      const selectedDocuments = hdrIds.map(d => ({ id: d }));

      FileSaver.saveAs(result.data, 'CycleCount.pdf');
      yield put(BinTrf02Actions.binTrf02RemoveSelectedDocuments(selectedDocuments));
      yield put(BinTrf02Actions.binTrf02ResetTimestamp());
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(BinTrf02Actions.binTrf02PrintBinTrf02Loading(false));
  }
}

export function* binTrf02GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/binTrfDetail/update/${hdrId}`));
}

export function* binTrf02NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/binTrfDetail/create/${app.curSiteFlowId}`));
}

export const saga = [
  takeLatest(BinTrf02Types.BIN_TRF02_GO_TO_DOCUMENT, binTrf02GoToDocument),
  takeLatest(BinTrf02Types.BIN_TRF02_FETCH_BIN_TRF02, binTrf02FetchBinTrf02),
  takeLatest(BinTrf02Types.BIN_TRF02_PRINT_BIN_TRF02, binTrf02PrintBinTrf02),
  takeLatest(BinTrf02Types.BIN_TRF02_NEW_DOCUMENT, binTrf02NewDocument)
];
